<template>
  <b-row>
    <b-col>
      <b-form-group :label="label" :label-for="fieldName">
        <b-form-textarea
          :id="fieldName"
          :placeholder="placeHolder"
          :required="required"
          :value="value"
          @input="updateValue($event)"
          :rows="rows"
          :max-rows="maxRows"
          v-bind="$attrs"
        ></b-form-textarea>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    fieldName: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeHolder: {
      type: String,
      default: "",
      required: false
    },
    required: {
      type: Boolean,
      default: false,
      required: false
    },
    value: {
      type: String,
      required: true,
      default: ""
    },
    rows: {
      type: Number,
      required: false,
      default: 3
    },
    maxRows: {
      type: Number,
      required: false,
      default: 6
    }
  },
  methods: {
    updateValue(val) {
      this.$emit("input", val);
    }
  }
};
</script>

<style lang="scss" scoped></style>
